/* Velura Global Animations - GSAP + Lenis */
document.fonts.ready.then(function () {
    // 1. Initialize Lenis (Smooth Scroll)
    if (typeof Lenis !== 'undefined') {
        const lenis = new Lenis({
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            direction: 'vertical',
            gestureDirection: 'vertical',
            smooth: true,
            mouseMultiplier: 1,
            smoothTouch: false,
            touchMultiplier: 2,
            infinite: false,
        });

        lenis.on('scroll', ScrollTrigger.update);
        gsap.ticker.add((time) => { lenis.raf(time * 1000); });
        gsap.ticker.lagSmoothing(0, 0);
    }

    // 2. Rotating Badge (Infinite + Scrub)
    if (document.querySelector('.rotating-badge svg')) {
        gsap.to(".rotating-badge svg", {
            rotation: 360,
            duration: 20,
            repeat: -1,
            ease: "linear"
        });
        gsap.to(".rotating-badge svg", {
            rotation: "+=180",
            scrollTrigger: {
                trigger: "body",
                start: "top top",
                end: "bottom bottom",
                scrub: 1
            }
        });
    }

    // 3. SplitText (Headings)
    if (typeof SplitType !== 'undefined') {
        const splitElements = document.querySelectorAll('.split-text');
        splitElements.forEach(el => {
            const text = new SplitType(el, { types: 'lines, words' });
            gsap.set(text.lines, { y: 50, opacity: 0 });

            ScrollTrigger.create({
                trigger: el,
                start: "top 85%",
                onEnter: () => {
                    gsap.to(text.lines, { y: 0, opacity: 1, duration: 1.2, stagger: 0.1, ease: "power3.out" });
                },
                once: true
            });
        });
    }

    // 4. Parallax Images standard (`img-parallax`)
    gsap.utils.toArray('.img-parallax').forEach(img => {
        const speed = img.getAttribute('data-speed') || 1.1;
        gsap.to(img, {
            yPercent: (speed - 1) * 100,
            ease: "none",
            scrollTrigger: { trigger: img.parentElement, start: "top bottom", end: "bottom top", scrub: true }
        });
    });

    // 5. Texture Spotlight Parallax (`texture-img-parallax`)
    if (document.querySelector('.texture-img-parallax')) {
        gsap.to(".texture-img-parallax", {
            yPercent: 15,
            ease: "none",
            scrollTrigger: { trigger: ".spotlight-v2", start: "top bottom", end: "bottom top", scrub: true }
        });
    }

    // 6. Generic Staggered Groups (Lists, Grids)
    ['.philosophy-grid', '.products-container', '.testi-grid', '.video-grid'].forEach(selector => {
        const wrap = document.querySelector(selector);
        if (wrap) {
            const staggers = wrap.querySelectorAll('.stagger-up, .product-stagger, .testi-card, .v-stagger');
            if(staggers.length > 0) {
                ScrollTrigger.create({
                    trigger: wrap,
                    start: "top 80%",
                    onEnter: () => gsap.fromTo(staggers, { opacity: 0, y: 50 }, { opacity: 1, y: 0, duration: 1.2, stagger: 0.15, ease: "power3.out" }),
                    once: true
                });
            }
        }
    });

    // 7. Generic Fade-ins
    gsap.utils.toArray('.fade-in-up:not(.delay-1, .delay-2, .delay-3)').forEach(el => {
        gsap.set(el, { opacity: 0, y: 30 });
        ScrollTrigger.create({
            trigger: el,
            start: "top 85%",
            onEnter: () => gsap.to(el, { opacity: 1, y: 0, duration: 1, ease: "power3.out" }),
            once: true
        });
    });
});
